import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  FormControl,
  Checkbox,
  ListItemIcon,
  Icon,
  OutlinedInput,
  Divider,
  ListItemSecondaryAction,
  ListItem,
  ListItemText,
  List,
  Select,
  MenuItem,
  TextField,
} from '@material-ui/core';

// services
import DashboardService from '@pingum/api-services/DashboardService';
import TenantService from '@pingum/api-services/TenantService';

// components
import FilterStatus from '../../../DashboardPage/FilterStatus';
import FilterEvent from '../../../DashboardPage/FilterEvent';
import FilterTags from '../../../DashboardPage/FilterTags';
import Property from '../../../../widgets/Property';
import DisplayMessage from '../../../../widgets/DisplayMessage';
import EventDataSelector from '../../../../forms/EventDataSelector';
import views, { getIconForView } from '../../../DashboardPage/DashboardViewSelector/defaultViews';
// utils
import { getTenantFromUrl } from '../../../../../utils/urlHelper';

import styles from './styles';

export class DashboardFormComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { validation: { name: true } };
  }

  checkAllValid = () => this.state.validation.name

  handleNameChange = (e) => {
    const changedValue = e.target.value;
    const isValid = changedValue !== null && changedValue !== undefined
    && changedValue.length >= 2 && changedValue.length <= 50;
    this.setState((prevState) => ({
      validation: {
        ...prevState.validation,
        name: isValid,
      },
    }));
    const updatedDashboard = {
      ...this.props.dashboard,
      directLinkName: TenantService.normalizeName(changedValue),
      name: changedValue,
      allValid: this.checkAllValid(),
    };
    this.props.handleDashboardUpdate(updatedDashboard);
  }

  handleOrganizationExposedChange = (e) => {
    const updatedDashboard = {
      ...this.props.dashboard,
      organizationExposed: e.target.value !== 'true',
      allValid: this.checkAllValid(),
    };
    this.props.handleDashboardUpdate(updatedDashboard);
  }

  handleViewChange = (e) => {
    const updatedDashboard = {
      ...this.props.dashboard,
      allValid: this.checkAllValid(),
      defaultView: e.target.value,
    };
    this.props.handleDashboardUpdate(updatedDashboard);
  }

  updateSearchEventsState = (data, field) => {
    const updatedDashboardData = this.props.dashboard.dashboardData;
    updatedDashboardData[field] = data;
    const updatedDashboard = {
      ...this.props.dashboard,
      dashboardData: updatedDashboardData,
      allValid: this.checkAllValid(),
    };
    this.props.handleDashboardUpdate(updatedDashboard);
  }

  handleChangeEventData = (eventData) => {
    const updatedDashboard = {
      ...this.props.dashboard,
      // eslint-disable-next-line no-unused-vars
      selectedColumns: [Object.assign({}, ...Object.entries({ ...eventData }).map(([a, b]) => ({ [b.name]: 'highlight' })))],
      allValid: this.checkAllValid(),
    };
    this.props.handleDashboardUpdate(updatedDashboard);
  }

  render() {
    const {
      classes,
      dashboard,
      isAdmin,
      eventData,
    } = this.props;

    return (
      !dashboard.id
        ? (
          <DisplayMessage
            subTitle="Select or add a dashboard to get started"
            icon="info_outline"
          />
        )
        : (
          <div>
            <TextField
              fullWidth
              className={classes.dashboardNameTextField}
              error={!this.state.validation.name}
              variant="outlined"
              id="dashboard-input"
              value={dashboard.name}
              label="Dashboard Name"
              onChange={this.handleNameChange}
              labelWidth={125}
              helperText={
                  !this.state.validation.name
                && 'Please provide a valid name (between 2 and 50 characters in length).'
                }
            />

            <Property label="Direct Link">
              <a
                href={DashboardService.getDashboardUrl(
                  TenantService.getTenantUrl(getTenantFromUrl()),
                  dashboard.directLinkName,
                )}
                target="_blank"
                rel="noopener noreferrer"
              >
                {
                DashboardService.getDashboardUrl(
                  TenantService.getTenantUrl(getTenantFromUrl()),
                  dashboard.directLinkName,
                )
              }
              </a>
            </Property>

            <Property label="Dashboard View">
              <FormControl fullWidth variant="outlined">
                <Select
                  value={dashboard.defaultView}
                  onChange={this.handleViewChange}
                  input={(
                    <OutlinedInput
                      margin="dense"
                      name="view"
                      id="list-select"
                      classes={{ input: classes.selectInput }}
                    />
                  )}
                  renderValue={(view) => (
                    <ListItem style={{ padding: 0 }}>
                      <ListItemIcon>
                        <Icon>{getIconForView(view)}</Icon>
                      </ListItemIcon>
                      <ListItemText style={{ padding: 0 }}>{view}</ListItemText>
                    </ListItem>
                  )}
                >
                  {
                  views.map((view) => (
                    <MenuItem
                      key={`view-${view.name}`}
                      value={view.key}
                      onClick={this.handleViewChange}
                    >
                      <ListItemIcon>
                        <Icon>{view.icon}</Icon>
                      </ListItemIcon>
                      <ListItemText style={{ padding: 0 }}>{view.name}</ListItemText>
                    </MenuItem>
                  ))
                }
                </Select>
              </FormControl>
            </Property>

            {
            isAdmin
            && (
              <Property label="Share with organization">
                <List>
                  <ListItem style={{ padding: 0 }}>
                    <ListItemIcon>
                      <Icon>
                        public
                      </Icon>
                    </ListItemIcon>
                    <ListItemText primary="Shared" />
                    <ListItemSecondaryAction>
                      <Checkbox
                        checked={dashboard.organizationExposed}
                        color="primary"
                        value={dashboard.organizationExposed}
                        onClick={this.handleOrganizationExposedChange}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
              </Property>
            )
          }

            <div className={classes.gridRoot}>
              <FilterEvent
                updateSearchEventsState={this.updateSearchEventsState}
                overrideSearchEvents={dashboard.dashboardData}
                overrideSelectedView={{ key: dashboard.defaultView }}
              />
              <Divider />
              <FilterStatus
                updateSearchEventsState={this.updateSearchEventsState}
                overrideSearchEvents={dashboard.dashboardData}
              />
              <Divider />
              <FilterTags
                updateSearchEventsState={this.updateSearchEventsState}
                overrideSearchEvents={dashboard.dashboardData}
              />
              <Divider />
              <FormControl
                margin="normal"
                fullWidth
                variant="outlined"
              >
                <EventDataSelector
                  // onInputValueChange={handleChangeEventDataInput}
                  // inputValue={eventDataInputValue}
                  availableItems={eventData}
                  selectedItem={eventData.filter((ed) => ((dashboard.selectedColumns || [])[0] || {})[ed.name] !== undefined)}
                  onChange={this.handleChangeEventData}
                  // itemToString={(eventDataItem) => eventDataItem.name}
                  eventData={eventData}
                  label="Highlighted Custom Fields"
                  helperText="Select the custom fields to highlight on the dashboard list, grid, and kanban views."
                />
              </FormControl>
            </div>
          </div>
        )
    );
  }
}

DashboardFormComponent.propTypes = {
  classes: PropTypes.object,
  dashboard: PropTypes.object,
  isAdmin: PropTypes.bool,
  eventData: PropTypes.array,
  handleDashboardUpdate: PropTypes.func,
};

DashboardFormComponent.defaultProps = {
  classes: {},
  dashboard: {},
  eventData: [],
  isAdmin: false,
  handleDashboardUpdate: () => {},
};

export default (withStyles(styles, { withTheme: true })(DashboardFormComponent));
